<template>
  <div class="table-responsive">
    <div class="modal fade" id="cardModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
      aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header" style="color: black">
            <h5 class="modal-title">Create card of ticket</h5>
          </div>
          <div class="modal-body" style="height: 400px; max-height: 400px">
            <div class="col-md-12">
              <div class="form-group">
                <label>Select board list:</label>
                <select v-model="ticketForm.list_id" class="form-control" style="padding: 5px 10px"
                  placeholder="Select list">
                  <option v-for="list in board_lists" :value="list.id">
                    {{ list.name }}
                  </option>
                </select>
              </div>
            </div>
            <div class="col-md-12">
              <label class="label-form" for="message">Card Title:</label>
              <input v-model="ticketForm.list_card_title" class="form-control" type="text" />
            </div>
            <div class="col-md-12">
              <label class="label-form" for="message">Card Description:</label>
              <textarea v-model="ticketForm.list_card_desc" class="form-control" type="text" rows="6"></textarea>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal" id="close">
              Close
            </button>
            <button type="button" class="btn btn-primary" @click="saveCard()">
              Send
            </button>
          </div>
        </div>
      </div>
    </div>
    <table class="table table-hover" id="dataTable" width="100%" cellspacing="0">
      <thead>
        <tr>
          <th>Organization</th>
          <th>Title</th>
          <th>Category</th>
          <th>Generated On</th>
          <th>Last Modified On</th>
          <th>Delivery Date</th>
          <th>Status</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(ticket, key) in tickets" :demo="ticket" :key="ticket.id"
          v-bind:class="{ highlighted_row: ticket.unread >= 1 }">
          <td>{{ ticket.organization_name }}</td>
          <td>{{ ticket.title }}</td>
          <td>
            <span>{{ category[ticket.category] }}</span>
          </td>
          <td>{{ ticket.created_at }}</td>
          <td>{{ ticket.last_modified_on }}</td>
          <td>{{ ticket.delivery_date }}</td>

          <!-- Status -->
          <td>
            <select id="status" class="form-control" :data-status="ticket.status" :data-id="ticket.id"
              @change="changeTicketStatus">
              <option v-if="ticket.status == 0" value="0" selected>Open</option>
              <option v-else value="0">Open</option>
              <option v-if="ticket.status == 1" value="1" selected>
                In Progress
              </option>
              <option v-else value="1">In Progress</option>
              <option v-if="ticket.status == 2" value="2" selected>
                Dead Leads
              </option>
              <option v-else value="2">Dead Leads</option>
              <option v-if="ticket.status == 10" value="10" selected>
                Closed
              </option>
              <option v-else value="10">Closed</option>
            </select>
          </td>

          <!-- <td  v-if="ticket.status == 0">
            <span class="badge badge-success">Open</span>
          </td>
          <td v-else-if="ticket.status == 1">
            <span class="badge badge-info">Dead Leads</span>
          <td v-else>
            <span class="badge badge-secondary">Closed</span>
          </td> -->

          <!-- controls [View, Delete] -->
          <td>
            <!-- <div class="btn-group btn-group-sm">
              <router-link
                v-if="$gate.allow('view', 'support', ticket)"
                :to="'/support/ticket/' + ticket.id"
                class="btn btn-success"
              >View</router-link>
              <button
                v-if="$gate.allow('delete', 'support', ticket)"
                @click="deleteTicket(ticket)"
                type="button"
                class="btn btn-danger"
              >Delete</button>
            </div> -->
            <a class="btn dropdown-toggle" data-toggle="dropdown" href="#">
              <span class="fas fa-ellipsis-v"></span>
            </a>
            <ul class="dropdown-menu">
              <template>
                <router-link :to="
                    '/support/ticket/' +
                    ticket.id +
                    '/' +
                    ticket.organization_id
                  " class="dropdown-item">View</router-link>
                <a class="dropdown-item text-danger" @click="deleteTicket(ticket)">Delete</a>
                <a class="dropdown-item" v-if="ticket.trello_list_id == null && ticket.status != 10"
                  @click="addToTrello(ticket.id, key)">Move To Trello</a>
              </template>
            </ul>
          </td>
        </tr>
      </tbody>
    </table>

    <h5 style="text-align: center" v-if="tickets.length < 1">No data found.</h5>

    <paginate v-model="currentPage" :page-count="totalPages" :click-handler="setPage" :prev-text="''" :next-text="''"
      :first-button-text="''" :last-button-text="''" :first-last-button="true"
      :container-class="'pagination pagination-sm float-right mt-3 mr-3'" :page-class="'page-item'"
      :prev-class="'page-item prev'" :next-class="'page-item next'" :page-link-class="'page-link'"
      :prev-link-class="'page-link'" :next-link-class="'page-link'"></paginate>
  </div>
</template>

<script>
  import axios from "axios";
  import moment from "moment";
  export default {
    props: ["request", "request", "totalPages", "page", "status"],
    data: function () {
      return {
        board_lists: [],
        selected_request_key: "",
        requestForm: {
          request_id: "",
        },
      };
    },
    computed: {
      currentPage: {
        get: function () {
          return this.page;
        },
        set: function () { },
      },
    },
    created: function () {
      this.getlist();
    },
    methods: {
      empty(str) {
        return !str || !/[^\s]+/.test(str);
      },
      saveCard() {
        if (
          this.empty(this.ticketForm.list_card_title) ||
          this.ticketForm.list_id == "" ||
          this.empty(this.ticketForm.list_card_desc)
        ) {
          this.$store.dispatch(
            "message/update",
            {
              title: "Alert",
              body: `Field can not be empty.`,
              class: "warning",
              confirm: false,
            },
            { root: true }
          );
          return;
        }
        let loader = this.$loading.show({
          loader: "dots",
        });
        this.$store
          .dispatch("support/addCard", this.ticketForm)
          .then((val) => {
            // send successful message
            loader.hide();
            this.$store.dispatch(
              "message/update",
              {
                title: this.formHeader,
                body: `Card has been added successfully`,
                class: "success",
                confirm: false,
              },
              { root: true }
            );
            $("#close").click();
            if (this.tickets[this.selected_ticket_key]) {
              this.tickets[this.selected_ticket_key].trello_list_id =
                val.data.data.idList;
            }
          })
          .catch((error) => {
            let response = error.response;
            loader.hide();
            // send error message
            this.$store.dispatch(
              "message/update",
              {
                title: this.formHeader,
                body: response.data.message,
                itemsErrors: response.data.errors,
                class: "danger",
                confirm: false,
              },
              { root: true }
            );
          });
      },
      addToTrello(id, key) {
        this.ticketForm = {
          ticket_id: "",
          list_id: "",
          list_card_title: "",
          list_card_desc: "",
        };
        this.ticketForm.ticket_id = id;
        this.selected_ticket_key = key;
        $("#cardModal").modal();
      },
      getlist() {
        var url = "/support/get-board-list";
        axios
          .post(url, {
            _method: "GET",
          })
          .then((response) => {
            this.board_lists = response.data.data;
          });
      },
      setPage(page) {
        this.$emit("setPage", page);
      },

      deleteTicket(ticket) {
        this.$store.dispatch("message/update", {
          title: ticket.title,
          body: "Are you sure you want to delete this Ticket?",
          class: "danger",
          confirm: true,
        });

        this.$bus.$off("proceed");
        this.$bus.$once("proceed", () => {
          this.delete(ticket);
          this.$store.dispatch("message/close");
        });
      },

      delete(ticket) {
        this.$store
          .dispatch("support/deleteTicket", ticket)
          .then((message) => {
            // send successful message
            this.$store.dispatch(
              "message/update",
              {
                title: ticket.title,
                body: message,
                class: "success",
                confirm: false,
              },
              { root: true }
            );
            this.$gate.setUnreadTicketsCount();
          })
          .catch((error) => {
            // send error message
            this.$store.dispatch(
              "message/update",
              {
                title: ticket.title,
                class: "danger",
                body: error.response.data.message,
                errors: error.response.data.errors,
                confirm: false,
              },
              { root: true }
            );
          });
      },

      // change ticket status
      changeTicketStatus(event) {
        let status = event.target.value;
        let ticket_id = event.target.dataset.id;
        this.$store
          .dispatch("support/changeTicketStatus", {
            ticket_id: ticket_id,
            status: status,
          })
          .then((data) => {
            // send successful message
            this.$store.dispatch(
              "message/update",
              {
                title: "Support Tickets",
                body: `Ticket status has been updated successfully`,
                class: "success",
                confirm: false,
              },
              { root: true }
            );
          })
          .catch((error) => {
            let response = error.response;

            // send error message
            this.$store.dispatch(
              "message/update",
              {
                title: "Support Tickets",
                body: response.data.message,
                itemsErrors: response.data.errors,
                class: "danger",
                confirm: false,
              },
              { root: true }
            );
          });
      },
    },
  };
</script>
<style scoped>  

  table tr td:nth-child(1) {
    width: 20% !important;
  }

  table tr td:nth-child(2) {
    width: 20% !important;
  }

  table tr td:nth-child(3) {
    width: 20% !important;
  }

  table tr td:nth-child(4) {
    width: 9% !important;
  }

  table tr td:nth-child(5) {
    width: 9% !important;
  }

  table tr td:nth-child(6) {
    width: 9% !important;
  }

  table tr td:nth-child(7) {
    width: 8% !important;
  }

  table tr td:nth-child(8) {
    width: 5% !important;
  }

  @media only screen and (min-width: 1280px) and (max-width: 1724px) {
    td {
      font-size: 12px;
    }

    table tr td:nth-child(1) {
      width: 18% !important;
    }

    table tr td:nth-child(2) {
      width: 18% !important;
    }

    table tr td:nth-child(3) {
      width: 18% !important;
    }

    table tr td:nth-child(4) {
      width: 11% !important;
    }

    table tr td:nth-child(5) {
      width: 13% !important;
    }

    table tr td:nth-child(6) {
      width: 10% !important;
    }

    table tr td:nth-child(7) {
      width: 10% !important;
    }

    table tr td:nth-child(8) {
      width: 2% !important;
    }
  }
</style>